import React from 'react';
import { RecordingPlaylistPlayerStyled } from 'common/widgets/recording-player';
import { EventCombinationSetting, EventFilterEntry, EventFilterInfo, RecordingEvents, RecordingMetadata, RecordingPlayerSource } from 'common/widgets/recording-player/types';
import { IronContextRegistry } from 'common/report/context-registry';
import { DateRange } from 'common/widgets/date-range-picker/models/date-range';
import styles from './index.module.styl';
export type SessionReplayMainProps = {
  dateRange: DateRange;
  isLoading: boolean;
  isLoadingMoreReplays: boolean; // Lazy loading status when scrolling.
  loadMoreReplaysFn: () => void;
  replays: RecordingMetadata[];
  replayCount: number | null;
  initialEvents?: RecordingEvents[];
  combination: EventCombinationSetting;
  setDateRangeFn: (dateRange: DateRange) => void;
  setEventFilterInfoFn?: (eventFilters: EventFilterInfo[]) => void;
  setCombinationFn?: (combination: EventCombinationSetting) => void;
  filterEntries?: EventFilterEntry[];
  setFilterEntries?: (entries: EventFilterEntry[]) => void;
} & Pick<IronContextRegistry, `localStorageManager`>;
export function SessionReplayMain(props: SessionReplayMainProps) {
  return <div className={styles.sessionReplayPlayer} data-sentry-component="SessionReplayMain" data-sentry-source-file="index.tsx">
      <RecordingPlaylistPlayerStyled replays={props.replays} open source={RecordingPlayerSource.ReplayHome} localStorageManager={props.localStorageManager} setDateRangeFn={props.setDateRangeFn} replayDateRange={props.dateRange} loadingReplays={props.isLoading} setEventFilterInfoFn={props.setEventFilterInfoFn} loadMoreReplaysFn={props.loadMoreReplaysFn} isLoadingMoreReplays={props.isLoadingMoreReplays} replayCount={props.replayCount} initialEvents={props.initialEvents} combination={props.combination} setCombinationFn={props.setCombinationFn} filterEntries={props.filterEntries} setFilterEntries={props.setFilterEntries} data-sentry-element="RecordingPlaylistPlayerStyled" data-sentry-source-file="index.tsx" />
    </div>;
}